export const baseURL = process.env.REACT_APP_API_URL;
export const frontendURL = process.env.REACT_APP_FRONTEND_URL;
export const googleMapApiKey = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;